import { useEffect, useRef } from "react";

const ACTIVITY_EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "click"];

// Calls onWarn(true) `warnSeconds` before the deadline, and onIdle() at the deadline.
// Any user activity resets the timers and calls onWarn(false). Active only when enabled=true.
export function useIdleLogout(enabled, minutes, warnSeconds, onWarn, onIdle) {
  const warnTimer = useRef(null);
  const idleTimer = useRef(null);
  const onWarnRef = useRef(onWarn);
  const onIdleRef = useRef(onIdle);
  const suspended = useRef(false);
  onWarnRef.current = onWarn;
  onIdleRef.current = onIdle;

  useEffect(() => {
    if (!enabled) return undefined;
    const ms = minutes * 60 * 1000;
    const warnMs = Math.max(0, ms - warnSeconds * 1000);
    const clear = () => {
      if (warnTimer.current) clearTimeout(warnTimer.current);
      if (idleTimer.current) clearTimeout(idleTimer.current);
    };
    const arm = () => {
      clear();
      warnTimer.current = setTimeout(() => { suspended.current = true; onWarnRef.current && onWarnRef.current(true); }, warnMs);
      idleTimer.current = setTimeout(() => onIdleRef.current && onIdleRef.current(), ms);
    };
    const reset = () => {
      if (suspended.current) return; // during warning, only the explicit "Stay" button re-arms
      arm();
    };
    const onStay = () => { suspended.current = false; onWarnRef.current && onWarnRef.current(false); arm(); };
    ACTIVITY_EVENTS.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    window.addEventListener("idle-stay-active", onStay);
    arm();
    return () => {
      clear();
      ACTIVITY_EVENTS.forEach((e) => window.removeEventListener(e, reset));
      window.removeEventListener("idle-stay-active", onStay);
      suspended.current = false;
    };
  }, [enabled, minutes, warnSeconds]);
}
